import React from "react";
import "../styles/Legal.css";
import usePageMeta from "../hooks/usePageMeta";

interface ChangelogEntry {
  version: string;
  date: string;
  highlights: string[];
}

const ENTRIES: ChangelogEntry[] = [
  {
    version: "Apr 2026 update",
    date: "April 30, 2026",
    highlights: [
      "Comments now support @mentions and inline editing.",
      "Tasks: Block / Reopen quick actions and an Activity tab in the task dialog.",
      "Project archive: hide finished projects without deleting them.",
      "Per-account invoices visible from Account → Subscription.",
      "Notification preferences (Slack, in-app, daily/weekly digest) are now configurable.",
    ],
  },
];

const ChangelogPage: React.FC = () => {
  usePageMeta({
    title: "Changelog | PabSync",
    description:
      "What’s new in PabSync — product updates and improvements.",
    path: "/changelog",
  });

  return (
    <div className="legal-page">
      <main className="legal-container">
        <article className="legal-card">
          <h1 className="legal-title">Changelog</h1>
          <p className="legal-meta">What's new in PabSync.</p>

          {ENTRIES.map((e) => (
            <section key={e.version} style={{ marginTop: 32 }}>
              <h2 style={{ marginBottom: 4 }}>{e.version}</h2>
              <p className="legal-meta">{e.date}</p>
              <ul>
                {e.highlights.map((h, i) => (
                  <li key={i}>{h}</li>
                ))}
              </ul>
            </section>
          ))}
        </article>
      </main>
    </div>
  );
};

export default ChangelogPage;
